<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoContainer fluid>
      <SoRow>
        <SoCol>
          <DebtPaymentPlanFormWidget />
        </SoCol>
      </SoRow>
    </SoContainer>

    <template #sidePanel>
      <CustomerAccountInfoPanel />
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail />
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "@/views/customer/overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "@/views/customer/overview/CustomerAccountInfoRail.vue"
  import DebtPaymentPlanFormWidget from "./widgets/debtPaymentPlan/DebtPaymentPlanFormWidget.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoContainer from "@/components/SoContainer.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { RouteNames } from "@/types/router"

  export default defineComponent({
    components: {
      DebtPaymentPlanFormWidget,
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoRow,
      SoCol,
      SoContainer,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
    computed: {
      eligibility() {
        return this.current.debtPaymentPlanEligibility
      },
      isEligible() {
        return this.eligibility.data.isEligible
      },
    },

    watch: {
      eligibility: {
        immediate: true,
        deep: true,
        handler(query: typeof this.eligibility) {
          const isEligible = query.data
          if (!isEligible && query.isFetched) {
            // Redirect back to financials page if not eligible
            this.$router.push({ name: RouteNames.CustomerFinancials })
          }
        },
      },
    },
  })
</script>
